import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps'

export default {
	getLandDocuments: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.LAND_DOCUMENTS].GET_LAND_DOCUMENTS,
	},
	getLandDocument: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.LAND_DOCUMENTS].GET_LAND_DOCUMENT,
	},
	createLandDocument: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.LAND_DOCUMENTS].CREATE_LAND_DOCUMENT,
	},
	putLandDocument: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.LAND_DOCUMENTS].PUT_LAND_DOCUMENT,
	},
	patchLandDocument: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.LAND_DOCUMENTS].PATCH_LAND_DOCUMENT,
	},
	deleteLandDocument: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.LAND_DOCUMENTS].DELETE_LAND_DOCUMENT,
	},
	getLandDocumentPreview: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.LAND_DOCUMENTS].GET_LAND_DOCUMENT_PREVIEW,
	},
	getLandDocumentPopup: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.LAND_DOCUMENTS].GET_LAND_DOCUMENT_POPUP,
	},
}
